"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
const messageHandlers_1 = require("../../handlers/messageHandlers");
const LoadMessagesWidget = ({ numberOfPages, flightData, receiverData, initiatorData, nextPage }) => {
    const [t] = (0, react_i18next_1.useTranslation)("i18n");
    return ((0, jsx_runtime_1.jsx)("div", { style: { display: "flex", justifyContent: "center", cursor: "pointer" }, onClick: () => {
            (0, messageHandlers_1.loadNextPage)({
                numberOfPages,
                flightData,
                receiverData,
                initiatorData,
                nextPage
            }).then();
        }, children: (0, jsx_runtime_1.jsx)("span", { className: "font-14-400", children: t("messages.more-messages") }) }));
};
exports.default = LoadMessagesWidget;
